export default __webpack_public_path__ + "static/react-icon-bcf6771acef94167edff572a213702d5.svg";